import React, { useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, Stack, IconButton, Popover } from '@mui/material';
import i18n from '../../../lang/translationConfig';

const LANGS = [
  {
    value: 'ko',
    label: 'Korea',
    icon: '/assets/icons/ic_flag_kor.svg',
  },
  {
    value: 'en',
    label: 'English',
    icon: '/assets/icons/ic_flag_en.svg',
  },
];

export default function LanguagePopover() {
  const lng = localStorage.getItem('i18nextLng') ?? 'ko';
  const init = LANGS.find((i) => i.value === lng);
  const [open, setOpen] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(init); // Add state for selected language

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language); // Update the selected language
    changeLanguage(language.value);
    handleClose();
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // useEffect( () => {
  //   if(langInfo === undefined){
  //     dispatch({ type: COMMON_LANG_TYPE, Common_Lang_Type: 'ko'})
  //   }else {
  //     i18n.changeLanguage(langInfo)
  //   }
  // },[])

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}
      >
        <img src={selectedLanguage.icon} alt={selectedLanguage.label} width="28" /> {/* Update the icon */}
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Stack spacing={0.75}>
          {LANGS.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === selectedLanguage.value}
              onClick={() => handleLanguageChange(option)}
            >
              <Box component="img" alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />
              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
